import { createContext, useContext, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = auth
  const [error, setError] = useState("");

  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));

  useEffect(() => { refresh(); }, []);

  // Superadmin (correo + contraseña)
  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(errMsg(e));
      return false;
    }
  };

  // Paso 1 del login POS: confirmar empresa por código
  const companyLookup = async (codigo) => {
    const { data } = await api.post("/auth/company-lookup", { codigo });
    return data;
  };

  // Paso 2 del login POS: usuario + PIN
  const posLogin = async (codigo, username, pin) => {
    setError("");
    try {
      const { data } = await api.post("/auth/pos-login", { codigo, username, pin });
      setUser(data);
      return true;
    } catch (e) {
      setError(errMsg(e));
      return false;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, companyLookup, posLogin, logout, refresh, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
